import { Close } from '@mui/icons-material'
import { DialogContent, IconButton } from '@mui/material'
import type { ReactNode } from 'react'

import CustomDialog from '@/components/feedback/CustomDialog'

type ExpandChartDialogProps = {
  open: boolean
  onClose: () => void
  title: string
  children: ReactNode
}

function ExpandChartDialog({ open, onClose, title, children }: Readonly<ExpandChartDialogProps>) {
  return (
    <CustomDialog open={open} size="large" title={title} onClose={onClose}>
      <IconButton aria-label="close" sx={{ position: 'absolute', right: 8, top: 8 }} onClick={onClose}>
        <Close />
      </IconButton>
      <DialogContent>{children}</DialogContent>
    </CustomDialog>
  )
}

export default ExpandChartDialog
